import {useParams} from "react-router-dom";
import {useUserGetQuery} from "../../app/api/api";
import QueryErrorAlert from "../../components/QueryErrorAlert";
import UserDetailForm from "./UserDetailForm";
import Page, {ContentTitle, Content} from "../../components/Layout/Page";

export default function UserDetails() {
    const params = useParams();
    const userId = parseInt(params.userId || "");
    const {data: user, error} = useUserGetQuery(userId);

    if (error) {
        return <QueryErrorAlert error={error} />;
    }

    return (
        <Page>
            <ContentTitle
                titleKey="generic_user"
                subtitle={user ? `${user.firstName} ${user.lastName}` : undefined}
                entry={user}
            />
            {user && (
                <Content>
                    <UserDetailForm user={user} />
                </Content>
            )}
        </Page>
    );
}
